<button mat-flat-button [type]="type" [color]="color" [disabled]="disabled" class="square-icon-btn">
    <mat-icon>{{icon}}</mat-icon>
</button>